import { RouteConfigParams } from './route-config-entry/route-config-entry.component';
import { EventEmitter, Injectable } from '@angular/core';
import { RouteInfo } from 'app/model/services/route.service';

@Injectable({
  providedIn: 'root'
})
export class RouteConfigDialogService {
  public requests = new EventEmitter<RouteConfigParams|undefined>();

  constructor() { }
  Show(params?:RouteConfigParams): void {
    this.requests.emit(params);
  }
}
